import { graphql } from 'gatsby'
import React, { useEffect, useState } from 'react'
import ColumnBackAndForth from '../../../components/atoms/columnBackAndForth'
import SEO from '../../../components/atoms/seo'
import { ITopicPath } from '../../../components/atoms/topicPath'
import ColumnDetailInner0089 from '../../../components/molecules/columnDetailInner0089'
import ColumnDetailsBody from '../../../components/organisms/columnDetailsBody'
import ColumnLayout from '../../../components/organisms/columnLayout'
import Conclusion001 from '../../../components/molecules/Conclusion001'
import Conclusion002 from '../../../components/molecules/Conclusion002'
import Conclusion003 from '../../../components/molecules/Conclusion003'
import Conclusion004 from '../../../components/molecules/Conclusion004'
import Conclusion005 from '../../../components/molecules/Conclusion005'
import Conclusion006 from '../../../components/molecules/Conclusion006'
import Conclusion007 from '../../../components/molecules/Conclusion007'
import Conclusion008 from '../../../components/molecules/Conclusion008'
import Conclusion009 from '../../../components/molecules/Conclusion009'
import CarouselBanner from '../../../components/molecules/carouselBanner'
import PopupBanner from '../../../components/molecules/popupBanner'
import ColumnAuthor004 from '../../../components/molecules/columnAuthor004'
import UsefulFunctionLayout010 from '../../../components/molecules/usefulFunctionLayout010'
import useRouteParam from '../../../hooks/useRouteParam'

/**
 * コラム記事詳細画面
 * @constructor
 */
const C0089 = () => {
  const paths: ITopicPath[] = [
    { title: 'キンクラコラムTOP', link: useRouteParam('/column') },
    { title: 'コラム記事一覧', link: useRouteParam('/column/list') },
    {
      title: '中小企業向け勤怠管理システムの選び方とは？おすすめシステムも紹介',
    },
  ]

  // 0~8ランダム数字を保存
  const [no, setNo] = useState(-1)
  useEffect(() => {
    setNo(Math.floor(Math.random() * 9))
  }, [])

  return (
    <ColumnLayout paths={paths}>
      <SEO
        title="中小企業向け勤怠管理システムの選び方とは？おすすめシステムも紹介"
        description="本記事では、中小企業に最適な勤怠管理システムの選び方を解説しています。コスト削減につながる活用方法や、多様な打刻方法、各種勤務形態への対応など、中小企業向け勤怠管理システムについてご紹介します。"
        ogUrl="https://kintaicloud.jp/column/details/C0089/"
        ogType="article"
        ogTitle="中小企業向け勤怠管理システムの選び方とは？おすすめシステムも紹介"
        ogDescription="本記事では、中小企業に最適な勤怠管理システムの選び方を解説しています。コスト削減につながる活用方法や、多様な打刻方法、各種勤務形態への対応など、中小企業向け勤怠管理システムについてご紹介します。"
        ogSiteName="キンクラ - 客先常駐特化型のクラウド勤怠管理システム"
        ogImage="https://www.kintaicloud.jp/images/column/details/c0089.jpg"
      />
      <ColumnDetailsBody>
        {/** ポップアップバナー */}
        <PopupBanner />
        {/** 記事本体 */}
        <ColumnDetailInner0089 no={no} />

        {/** ここに9パターンの広告設定する */}
        {no === 0 && <Conclusion001 />}
        {no === 1 && <Conclusion002 />}
        {no === 2 && <Conclusion003 />}
        {no === 3 && <Conclusion004 />}
        {no === 4 && <Conclusion005 />}
        {no === 5 && <Conclusion006 />}
        {no === 6 && <Conclusion007 />}
        {no === 7 && <Conclusion008 />}
        {no === 8 && <Conclusion009 />}

        {/** オーサ情報 */}
        <ColumnAuthor004 />
        {/** お役立ち機能 */}
        <UsefulFunctionLayout010 />
        {/** 前後記事への遷移 */}
        <ColumnBackAndForth />
        {/** カルーセルバナー */}
        <CarouselBanner />
        {/** 関連記事 */}
        {/* <ColumnRelationCards0089 /> */}
      </ColumnDetailsBody>
    </ColumnLayout>
  )
}

export default C0089

export const pageQuery = graphql`
  query C0089 {
    site {
      siteMetadata {
        title
      }
    }
  }
`
